import {GenericIdentifier} from 'app-ui-componentlibrary/dist/go/components/common/genericCard/genericIdentifier';
import React from 'react';
import {Card, Grid} from 'semantic-ui-react';
import _ from 'lodash';
import {evaluateOperator} from 'common/utils';
// cardContents array of type, status, subrecipient, dueDate, actionLink
// object of form {name, value}
const ThingToDoCard = ({cardContents, cardWidth}) => {
  // console.log({cardContents});
  return (
    <React.Fragment>
      <Card className="grid-display-card" fluid>
        <Grid.Column mobile={16} computer={12} align="left">
          <Grid className="grid-display-card" columns={6}>
            {cardContents &&
              cardContents.map((content) => (
                <>
                  {_.isEqual(content.name, 'Funding Opportunity Name') && (
                    <Grid.Row
                      className={content.isPastDue ? 'thingsToDoLate' : 'thingsToDo'}
                      width="100%"
                    >
                      {content.value}
                    </Grid.Row>
                  )}
                  {_.isEqual(content.name, 'Due Date') && (
                    <Grid.Column id={`${content.name}-column`} width={cardWidth}>
                      <Grid.Row className="generic-card-row --header">
                        {content.name}
                      </Grid.Row>
                      <Grid.Row
                        className={`generic-card-row --text ${
                          content.isPastDue && '--header pastDueColor'
                        } alignCenter`}
                      >
                        {content.value && content.isPastDue && (
                          <img
                            className="due-date-alert"
                            src={'/assets/error-alert.svg'}
                            width="18px"
                            style={{marginRight: '3px'}}
                          />
                        )}
                        {content.value}
                      </Grid.Row>
                    </Grid.Column>
                  )}
                  {!_.isEqual(content.name, 'Funding Opportunity Name') &&
                    !_.isEqual(content.name, 'Due Date') && (
                      <Grid.Column id={`${content.name}-column`} width={cardWidth}>
                        <GenericIdentifier
                          titles={[content.name]}
                          contents={[content.value]}
                        />
                      </Grid.Column>
                    )}
                </>
              ))}
          </Grid>
        </Grid.Column>
      </Card>
      <br />
    </React.Fragment>
  );
};

export default ThingToDoCard;
